import { REQUEST_SENT_WITH } from "../../../../enums/Profile/profile";

export const requestSenderAction = (data) => {
    return {
        type: REQUEST_SENT_WITH,
        payload: data,
    };
};
